import React, { useEffect, useState} from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import Cookies from 'universal-cookie';



const StudentDashboard = () => {
  const [modules, setModules] = useState([]);
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("userData"))
  const token = user?.token
  const cookie = new Cookies();

   console.log('cookie', cookie);
  const jwt = cookie.get("jwt");
  console.log(jwt);

  // const jwt = user?.jwt;

  // const headers = {
  //   "Content-Type": "application/json",
  //    Authorization: `Bearer ${token} `,
  //   'withCredentials': true,
  //   'jwt': `Bearer ${jwt}`
  // };

  const getModules = () => {
    setIsLoading(true)
    axios
      .get(
        `${process.env.REACT_APP_API_URL}api/v1/get-all-modules`, {withCredentials : true}
      )
      .then((response) => {
        setModules(response?.data?.data?.data);
        setIsLoading(false)
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
        if (
          error?.response?.status === 400 &&
          error?.response?.data?.error === "Session Expired"
        ) {
          alert("Session expired. Please login again.");
          navigate("/login");
        }
      });
  }

  useEffect(() => {
    console.log("before get modules")
    getModules()
  },[]);



  // if(modules.length===0){
  //   return (<div className='flex justify-center text-lg mt-24'>No Assesments found!</div> )
  // }

  if(isLoading) 
  return <div className='flex justify-center w-full mt-24'>
          <svg aria-hidden="true" className="inline w-7 h-7 text-primary animate-spin  fill-white" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
              <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
          </svg>
      </div>

  return (
    <div>
    <div className='flex mt-10 justify-start items-center p-4 gap-6 flex-wrap font-pop'>
      {
        modules.length===0? <p className='text-lg text-center w-full mt-12'>No Assesments Found!</p> :
        modules.map((module, index) => (
          <div className='shadow-md p-4 m-2 rounded-xl w-[280px] md:w-[300px] flex justify-between flex-col gap-4 h-[240px]' key={index}>
          <p className='text-primary text-base font-medium capitalize line-clamp-2'>{module?.module_name}</p>
          <p className='text-sm font-medium line-clamp-2'><span className='font-normal'>Course name :  </span>{module?.event_name}</p>
          <p className='text-sm font-medium'><span className='font-normal'>Number of questions :  </span>{module?.questions.length}</p>
          <button onClick={()=>navigate(`/assessment/${module?.module_id}/${module?.module_name}`,{state:module})} className='bg-secondary px-3 py-2  my-2 text-white outline-0 border-0 rounded-md text-sm'>Start Assessment</button>
          </div>
        ))
      }
    </div>
  </div>
  )
}

export default StudentDashboard;